import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReleaseNotesRoute: InvariantJiraRoute = {
	name: 'software-release-notes',
	path: '/secure/ReleaseNote.jspa',
	query: ['projectId'],
};
